import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormBuilder, FormField, Input, InputState, usePrevious } from '@as/cotopaxi';
import { MagnifyingGlassIcon, XIcon } from '@yonderland/andes-icons';
import { IconButton } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const initialValuesContentOverviewForm = {
    contentSearch: '',
};
const SearchChangeHandler = ({ initialValues, contentSearch, onChange, }) => {
    const prevContent = usePrevious(contentSearch);
    useEffect(() => {
        if (prevContent !== contentSearch && initialValues.contentSearch !== contentSearch) {
            onChange(contentSearch);
        }
    }, [contentSearch, onChange, prevContent, initialValues]);
    return null;
};
export const ContentOverviewForm = ({ initialValues, onSubmit, onSearchChange, handleResetValues, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    return (_jsx(FormBuilder, { onSubmit: onSubmit, initialValues: initialValues, name: "content-overview-form", children: ({ errors, touched, values, setValues }) => (_jsxs(_Fragment, { children: [_jsx(SearchChangeHandler, { initialValues: initialValues, onChange: onSearchChange, contentSearch: values.contentSearch }), _jsx(FormField, { name: "contentSearch", placeholder: t('flyout.search.placeholder'), state: errors.contentSearch && touched.contentSearch ? InputState.ERROR : undefined, adornmentEnd: _jsxs(_Fragment, { children: [values.contentSearch && !errors.contentSearch && (_jsx(IconButton, { onClick: () => {
                                    setValues(initialValuesContentOverviewForm);
                                    handleResetValues();
                                }, variant: "plain", size: "sm", icon: { source: XIcon, color: 'subtle' } })), _jsx(IconButton, { type: "submit", variant: values.contentSearch && !errors.contentSearch ? 'primary' : 'plain', size: "sm", icon: {
                                    source: MagnifyingGlassIcon,
                                    color: !values.contentSearch || errors.contentSearch ? 'subtle' : null,
                                } })] }), Component: Input })] })) }));
};
